import { DEFAULT_STATE } from '@/modules/sale/constants';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  ...DEFAULT_STATE,
  list: {
    data: []
  },
  item: null,
  totalCount: 0,
  params: {
    statusIds: [],
    draftStatusIds: [], // include FAKE_ON_HOLD_STATUS_ID
    customerBuyerIds: [],
    isIncludeTotalCount: true,
    isLoadMore: false,
    limit: 5,
    offset: 0,
    startDeliveryDate: null,
    endDeliveryDate: null,
    blockStatus: []
  },
  customerAndStatus: null,
  detailPurchase: null,
  itemDisputes: null,
  invoiceList: null,
  invoice: null,
  sendInvoiceToPeppolByOrderId: false,
  customerPeppol: null,
  tenantIntegrationStorecove: null,
  repeatOrder: null,
  viewPrice: null,
  list_customer_sale: [],
  totalCountCompany: 0,
  isRepeatOrderSuccess: false,
  unAvailableRepeatSkuIds: [],
  isEnableSoftBlockOrder: false
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
